import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {GetProfileResponse} from "@/types/user";

interface ProductGroup {
    id: string;
    name: string;
    picture: string;
    pLevel: number;
}

interface LayoutState {
    allowBottomNav: boolean;
    backScroll: number;
    profile: GetProfileResponse | null;
    isProfileLoading: boolean;
    productGroups: ProductGroup[];
}


const initialState: LayoutState = {
    allowBottomNav: true,
    backScroll: 0,
    profile: null,
    isProfileLoading: false,
    productGroups: [],
};


export const layoutSlice = createSlice({
    name: 'layout',
    initialState,
    reducers: {
        setProductGroups: (state, action: PayloadAction<ProductGroup[]>) => {
            state.productGroups = action.payload;
        },
        setAllowBottomNav: (state, action: PayloadAction<boolean>) => {
            state.allowBottomNav = action.payload
        },
        setBackScroll: (state, action: PayloadAction<number>) => {
            state.backScroll = action.payload
        },
        setProfile: (state, action: PayloadAction<GetProfileResponse | null>) => {
            state.profile = action.payload;
        },
        setProfileLoading: (state, action: PayloadAction<boolean>) => {
            state.isProfileLoading = action.payload;
        },
    }
})

export const {setProductGroups, setAllowBottomNav, setBackScroll, setProfile, setProfileLoading } = layoutSlice.actions
const layoutReducer = layoutSlice.reducer
export default layoutReducer

